module.exports = __webpack_public_path__ + "static/media/BallClay.655c412e.jpg";